module.exports = __webpack_public_path__ + "static/media/Feb_2026_4.aac4358a.webp";